import { COMMON_SHOW_NOTIFICATION } from 'redux/actions';
import {
  IEkycCheckDeviceIdParams,
  IEkycCheckExisted,
  IEkycParams,
} from 'interfaces/ekyc';
import { IRequest } from 'interfaces/common';
import { ToastType as NOTIFICATION_TYPE } from 'react-toastify';
import {
  CHECK_BLOCK_IP,
  CHECK_EXISTED_EKYC,
  REGISTER_EKYC,
} from 'screens/KisEkyc/action';
import { call, put, takeLatest } from 'redux-saga/effects';
import { query } from 'utils/socketApi';
import config from 'config';

const registerEkyc = (params: IEkycParams) => {
  return query(config.apis.ekycAdminEkyc, params);
};
const checkContactInfoIsExisted = (params: IEkycCheckExisted) => {
  return query(config.apis.checkContactInfoIsExisted, params);
};

const checkBlockIp = (param: IEkycCheckDeviceIdParams) => {
  return query(config.apis.checkBlockIp, param);
};

function* doRegisterEkyc(request: IRequest<IEkycParams>) {
  // console.log('registering');
  try {
    yield call(registerEkyc, request.payload);
    yield put({
      type: request.response.success,
    });
  } catch (error) {
    yield put({
      type: request.response.failed,
    });
    yield put({
      type: COMMON_SHOW_NOTIFICATION,
      payload: {
        type: NOTIFICATION_TYPE.ERROR,
        title: 'Register Ekyc',
        content: error.code ? error.code : error.message,
        time: new Date(),
      },
    });
  }
}

function* doCheckExistedEkyc(request: IRequest<IEkycCheckExisted>) {
  try {
    const response: { data: { message: string } } = yield call(
      checkContactInfoIsExisted,
      request.payload
    );
    yield put({
      type: request.response.success,
      payload: response.data.message,
    });
  } catch (error) {
    yield put({
      type: request.response.failed,
      payload: error.code || error.message,
    });
    // yield put({
    //   type: COMMON_SHOW_NOTIFICATION,
    //   payload: {
    //     type: NOTIFICATION_TYPE.ERROR,
    //     title: 'ID is Existed',
    //     content: error.code ? error.code : error.message,
    //     time: new Date(),
    //   },
    // });
  }
}

function* doCheckBlockIp(request: IRequest<IEkycCheckDeviceIdParams>) {
  try {
    const response: { data: { blocked: boolean } } = yield call(
      checkBlockIp,
      request.payload
    );

    yield put({
      type: request.response.success,
      payload: response.data.blocked,
    });
  } catch (error) {
    yield put({
      type: request.response.failed,
      payload: error.code || error.message,
    });
    yield put({
      type: COMMON_SHOW_NOTIFICATION,
      payload: {
        type: NOTIFICATION_TYPE.ERROR,
        title: 'BLOCK IP',
        content: error.code ? error.code : error.message,
        time: new Date(),
      },
    });
  }
}

export default function* watchRegisterEkyc() {
  yield takeLatest(REGISTER_EKYC, doRegisterEkyc);
  yield takeLatest(CHECK_EXISTED_EKYC, doCheckExistedEkyc);
  yield takeLatest(CHECK_BLOCK_IP, doCheckBlockIp);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/KisEkyc/Register.ts